module.exports = __webpack_public_path__ + "img/word4.07cc1fbe.webp";